export default __webpack_public_path__ + "static/media/flash18.fe8eb544.png";